import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import Paragraph from '../../../../../../../components/common/Paragraph';

const DeclarationModal = () => {
  const [isModalVisible, setModalVisible] = useState(false);

  const hideModal = () => setModalVisible(false);
  const openModal = () => setModalVisible(true);

  const modalFooter = (
    <Button type="primary" onClick={hideModal}>
      Entendido
    </Button>
  );

  return (
    <>
      <Button
        size="small"
        type="link"
        style={{ paddingLeft: '2px', paddingRight: '2px' }}
        onClick={openModal}
      >
        Servicio de cuentas de mandantes individuales
      </Button>
      <Modal footer={modalFooter} visible={isModalVisible} onCancel={hideModal} width={780}>
        <Paragraph strong>Declaración de origen de fondos</Paragraph>
        <Paragraph align="justify">
          Vantrust Capital Corredores de Bolsa S., con el objeto de dar cumplimiento a lo dispuesto en el Oficio Circular N°631 emitidos por la comisión  para el mercado financiero con fecha
          26 de Agosto de 2010, vieneen informar lo siguiente respecto del servicio de cuentas de mandantes individuales, en adelante CMI, de empresas de déposito de valores de la Ley N° 18.876.
        </Paragraph>
        <ol style={{ listStyleType: 'upper-roman' }}>
          <li>
            <b>Características del servicio de CMI.</b>
            <p>El servicio permite a clientes de corredores de bolsa y agentes de valores (mandantes) abrir a su nombre una cuenta en el DCV, elevando así la seguridad y un mayor control sobre la custodía de sus valores. El mandante podránconsultar y realizar un monitoreo de su cartera en línea y cada vez que lo desee, a través del portalsdel DCV
              en (www.dcv.cl)
            </p>
          </li>
          <li>
            <b>Procedimiento para la apertura.</b>
            <p> Cada Corredor de bolsa y agente de valores deberá definir sus propios procedimientos para formalizar el servicio con sus clientes mandantes.


            </p>
          </li>
        </ol>
      </Modal>
    </>
  );
};

export default DeclarationModal;
